import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, DeferLoadingStrategy, I18nModule, UrlModule, provideConfig } from '@spartacus/core';
import { LaunchDialogModalLayoutConfig } from 'src/app/dialog/custom-launch-dialog-config';
import { DynamicFormsModule } from '../../dynamic-forms/dynamic-forms.module';
import { ConfirmationPersonalInfoComponent } from './confirmation-personal-info/confirmation-personal-info.component';
import { MyaccountPersonalInfoComponent } from './myaccount-personal-info.component';
import { RequestDeletionModalComponent } from './request-deletion-modal/request-deletion-modal.component';

@NgModule({
  declarations: [MyaccountPersonalInfoComponent, ConfirmationPersonalInfoComponent, RequestDeletionModalComponent],
  imports: [
    CommonModule,
    DynamicFormsModule,
    I18nModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    ConfigModule.withConfig({
      cmsComponents: {
        PersonalInfoComponent: {
          component: MyaccountPersonalInfoComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideConfig({
      ...LaunchDialogModalLayoutConfig.MyAccounts,
    }),
  ],
})
export class MyaccountPersonalInfoModule {}
